import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AccessRole, ButtonColumnType, CustomTableComponent, DataColumnType, ICustomTable, LocalService, DATE_WITH_HOUR_FORMAT } from 'lib-base';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { firstValueFrom, forkJoin } from 'rxjs';
import { SolicitudActividadesService } from '../../../../services/database/pqrsd/solicitud-actividades.service';
import { SolicitudHistorialActividadComponent } from './solicitud-historial-actividad/solicitud-historial-actividad.component';
import { IGetMisPqrsd } from '../../../../shared/interfaces/database/pqrsd';

@Component({
  selector: 'app-solicitudes-historial',
  standalone: true,
  imports: [CommonModule, CustomTableComponent,
    TableModule, ButtonModule, SolicitudHistorialActividadComponent],
  templateUrl: './solicitudes-historial.component.html',
  styleUrl: './solicitudes-historial.component.scss'
})
export class SolicitudesHistorialComponent implements OnInit {
  @Input() tramEstados: string[] = [];
  @Input() tramActividadEstados: string[] = [];
  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  role = AccessRole;

  constructor(private readonly _t: TranslateService, private readonly _ls: LocalService, private readonly _sa: SolicitudActividadesService) {
  }

  ngOnInit(): void {
    this.translate().then(() => {
      this.configuraTable();
    });
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      radicado: this._t.get('common.radicado'),
      tipo: this._t.get('common.tipo'),
      observaciones: this._t.get('common.observaciones'),
      estado: this._t.get('common.estado'),
      fechaActualización: this._t.get('common.fechaActualización'),
      fechaSolicitud: this._t.get('common.fechaSolicitud')
    }));
  }

  configuraTable() {
    this.customTable = {
      columns: [
        {
          field: 'expand',
          header: '',
          class:'p-button-info',
          width: '0.5rem',
          buttonType: ButtonColumnType.EXPANDED
        },
        {
          field: 'radicado',
          header: this.trans.radicado,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'tipoDescripcion',
          header: this.trans.tipo,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'observacion',
          header: this.trans.observaciones,
          class:'font-13',
          width: "25em",
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'solicitudEstado',
          header: this.trans.estado,
          sort: true,
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: true,
          dataType: DataColumnType.ESTADO_TAG
        },
        {
          field: 'fechaActualizacion',
          header: this.trans.fechaActualización,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          format:DATE_WITH_HOUR_FORMAT,
          dataType: DataColumnType.DATE,
        },
        {
          field: 'fechaSolicitud',
          header: this.trans.fechaSolicitud,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          format:DATE_WITH_HOUR_FORMAT,
          dataType: DataColumnType.DATE,
        },
      ],
      settings: {
        table: {
          rows: 8
        }
      }
    } as ICustomTable;
  }

  getMisPqrsd() {
    this._sa.getMisPqrsd(this.tramEstados, this.tramActividadEstados).subscribe({
      next: (data: IGetMisPqrsd[]) => {
        this.customTableComponent.data = data;
      }
    });
  }
}
